export default __webpack_public_path__ + "static/media/scan_loaded_item_to_confirm.27b65893.svg";